import { render, staticRenderFns } from "./FormStep1.vue?vue&type=template&id=12306e3e"
import script from "./FormStep1.vue?vue&type=script&lang=js"
export * from "./FormStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports